// extracted by mini-css-extract-plugin
module.exports = {"container":"AddressInfo_container__m0fJY","nickname":"AddressInfo_nickname__3nhDQ","recipient":"AddressInfo_recipient__1cwJT"};